import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var tryCatchWrapper = function tryCatchWrapper(func) {
  return function () {
    try {
      return func.apply(void 0, arguments);
    } catch (e) {
      // ok to swallow error
      //
      // local/sessionStorage are non-critical benefits. If they happen to be available,
      // they're helpful, but if not, the SDK functions totally fine.
      //
      // If a function fails, behavior is functionally the same as if rememberMe is 'none'.
      console.warn('Error accessing browser storage. Defaulting to memory.\n\n', e);
    }
  };
};

var _getSeedName = function _getSeedName(appId, username) {
  return "userbaseSeed.".concat(appId, ".").concat(username);
};

var setCurrentSession = tryCatchWrapper(function (rememberMe, username, signedIn, sessionId, creationDate, expirationDate) {
  var session = {
    username: username,
    signedIn: signedIn,
    sessionId: sessionId,
    creationDate: creationDate,
    expirationDate: expirationDate
  };
  var sessionString = JSON.stringify(session);

  if (rememberMe === 'local') {
    localStorage.setItem('userbaseCurrentSession', sessionString);
  } else if (rememberMe === 'session') {
    sessionStorage.setItem('userbaseCurrentSession', sessionString);
  }
});
var getCurrentSession = tryCatchWrapper(function () {
  var sessionStorageCurrentSessionString = sessionStorage.getItem('userbaseCurrentSession');

  if (sessionStorageCurrentSessionString) {
    var currentSession = JSON.parse(sessionStorageCurrentSessionString);

    if (!currentSession.signedIn) {
      var localCurrentSessionString = localStorage.getItem('userbaseCurrentSession');

      if (localCurrentSessionString) {
        var localCurrentSession = JSON.parse(localCurrentSessionString); // allows session from localStorage to override sessionStorage if signed in
        // to localStorage session and not signed in to sessionStorage session

        if (localCurrentSession.signedIn) {
          return _objectSpread(_objectSpread({}, localCurrentSession), {}, {
            rememberMe: 'local'
          });
        }
      }
    }

    return _objectSpread(_objectSpread({}, JSON.parse(sessionStorageCurrentSessionString)), {}, {
      rememberMe: 'session'
    });
  }

  var localSessionString = localStorage.getItem('userbaseCurrentSession');
  return localSessionString && _objectSpread(_objectSpread({}, JSON.parse(localSessionString)), {}, {
    rememberMe: 'local'
  });
});
var saveSeedString = tryCatchWrapper(function (rememberMe, appId, username, seedString) {
  if (rememberMe === 'local') {
    localStorage.setItem(_getSeedName(appId, username), seedString);
  } else if (rememberMe === 'session') {
    sessionStorage.setItem(_getSeedName(appId, username), seedString);
  }
});
var removeSeedString = tryCatchWrapper(function (appId, username) {
  var seedName = _getSeedName(appId, username);

  sessionStorage.removeItem(seedName);
  localStorage.removeItem(seedName);
});
var getSeedString = tryCatchWrapper(function (appId, username) {
  var seedName = _getSeedName(appId, username);

  return sessionStorage.getItem(seedName) || localStorage.getItem(seedName);
});

var signInSession = function signInSession(rememberMe, username, sessionId, creationDate, expirationDate) {
  var signedIn = true;
  setCurrentSession(rememberMe, username, signedIn, sessionId, creationDate, expirationDate);
};

var signOutSession = function signOutSession(rememberMe, username) {
  var signedIn = false;
  setCurrentSession(rememberMe, username, signedIn);
};

var removeCurrentSession = tryCatchWrapper(function () {
  sessionStorage.removeItem('userbaseCurrentSession');
  localStorage.removeItem('userbaseCurrentSession');
});
export default {
  signInSession: signInSession,
  signOutSession: signOutSession,
  getCurrentSession: getCurrentSession,
  saveSeedString: saveSeedString,
  removeSeedString: removeSeedString,
  getSeedString: getSeedString,
  removeCurrentSession: removeCurrentSession
};